export default "__VITE_ASSET__DeQyElFI__"